import * as React from "react";
import { SVGProps } from "react";
const SvgQuoteFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25 3c2.2 0 4 1.8 4 4v11c0 2.2-1.8 4-4 4h-3v5a1 1 0 0 1-1.602.799L12.7 22H7c-2.2 0-4-1.8-4-4V7c0-2.2 1.8-4 4-4h18Zm-3.5 5h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1.499l-1.818 3.638a.25.25 0 0 0 .224.362h1.345a.5.5 0 0 0 .4-.2l2.75-3.667a.5.5 0 0 0 .099-.3L22 8.5a.5.5 0 0 0-.5-.5Zm-7 0h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1.499l-1.818 3.638a.25.25 0 0 0 .224.362h1.345a.5.5 0 0 0 .4-.2l2.75-3.667a.5.5 0 0 0 .099-.3L15 8.5a.5.5 0 0 0-.5-.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgQuoteFilled;
